/* eslint-disable react-hooks/exhaustive-deps */
import React, { createContext, useContext, useLayoutEffect } from "react";
import { useTranslation } from "react-i18next";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const { i18n } = useTranslation();

  const changeLanguage = (lng) => {
    const direction = lng === "he" ? "rtl" : "ltr";
    document.documentElement.lang = lng;
    document.documentElement.dir = direction;
    i18n.changeLanguage(lng);
  };

  useLayoutEffect(() => {
    const direction = localStorage.getItem("language") === "he" ? "rtl" : "ltr";
    document.documentElement.lang = localStorage.getItem("language");
    document.documentElement.dir = direction;
  }, []);

  return (
    <LanguageContext.Provider value={{ changeLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguageContext = () => useContext(LanguageContext);
